import * as HttpService from './HttpService'
import axios from 'axios'
import Messages from '@/constants/Messages'
import * as Enums from '@/constants/Enums'
import * as Common from '@/constants/Common'
import { v4 as uuidv4 } from 'uuid'
import ServiceEndpoints from '@/constants/ServiceEndpoints'
// import ReactFlagsSelect from 'react-flags-select'
import $ from 'jquery'
import dynamic from 'next/dynamic'
import SimpleReactValidator from 'simple-react-validator'
import { NumericFormat } from 'react-number-format'
import { Modal, Button } from 'react-bootstrap'
import * as RingBuilder from './RingBuilder'
import Skeleton from 'react-loading-skeleton'

export {
  HttpService,
  axios,
  Messages,
  Enums,
  Common,
  uuidv4,
  ServiceEndpoints,
  // ReactFlagsSelect,
  $,
  dynamic,
  SimpleReactValidator,
  NumericFormat,
  Modal,
  Button,
  RingBuilder,
  Skeleton
}
